import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './Footer';
import HeaderNew from './HeaderNew';

function DefaultLayout() {

  // const location = useLocation();

  // useEffect(() => {
  //   const path = location.pathname.split("/")[1]; // AE, SA, etc

  //   const validCountries = ["AE", "SA", "QA", "OM", "KW"];

  //   let countryCode = validCountries.includes(path) ? path : "IN";

  //   const countryMap = {
  //     AE: "UAE",
  //     SA: "KSA",
  //     QA: "Qatar",
  //     OM: "Oman",
  //     KW: "Kuwait",
  //     IN: "India"
  //   };

  //   const countryName = countryMap[countryCode];

  //   const data = { country: countryName, code: countryCode };

  //   // ✅ Sync storage
  //   localStorage.setItem("userLocation", JSON.stringify(data));
  //   localStorage.setItem("selectedCountry", countryName);
  //   localStorage.setItem("selectedCountryCode", countryCode);

  // }, [location.pathname]);

  return (
    
        <div className='fullscreen'>
            <HeaderNew/>

                <Outlet/>

            <Footer />
    </div>
  )
}

export default DefaultLayout
